import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { ExtraFieldName } from '@shared/model'
import type { ExtraFieldModel } from '../../extra-field-model.hook'

import { useListsStore } from '@shared/model'

import { useSelectConfigParser } from '../../select-config-parser.hook'
import { useExtraFieldModel } from '../../extra-field-model.hook'

interface SelectReasonReturn {
  name: ExtraFieldName
  placeholder: string
  model: ExtraFieldModel
  options: ComputedRef<AppSelectOption[]>
  isRequired: ComputedRef<boolean>
  isVisible: ComputedRef<boolean>
}

export const useSelectReason = (): SelectReasonReturn => {
  const listsStore = useListsStore()
  const name: ExtraFieldName = 'billing_reason'
  const placeholder = 'Select here'

  const model = useExtraFieldModel(name)

  const {
    options,
    extraFields,
  } = useSelectConfigParser({ name })

  const isRequired = computed(() => listsStore.getTasksKanbanConfig?.extra_fields[name]?.required || false)

  const isVisible = computed(() => extraFields.value.includes(name))

  return {
    name,
    placeholder,
    model,
    options,
    isRequired,
    isVisible,
  }
}
